<template lang="pug">
  ValidationProvider(
    name="Time"
    :rules="rules"
    v-slot="{ errors }"
    ref="timeValidator"
  )
    v-text-field(
      type="time"
      :value="value"
      :error-messages="errors"
      hide-details="auto"
      filled
      @input="$emit('input', $event)"
    )
</template>

<script>
export default {
  name: 'EInputTime',
  props: {
    value: {
      type: String,
      default: null
    },
    scheduledAt: {
      type: String,
      default: null
    }
  },
  computed: {
    minTime() {
      if (this.scheduledAt) this.$moment(this.scheduledAt).clone().add(6, 'minutes').format('HH:mm')
      return this.$moment().clone().add(6, 'minutes').format('HH:mm')
    },
    rules() {
      return {
        required: true,
        min_time: this.minTime
      }
    }
  },
  methods: {
    validate() {
      return this.$refs.timeValidator.validate()
    }
  }
}
</script>

<style scoped lang="scss">
.e-input-time {
  outline: none;
  margin-left: 12px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
  }

  &-wrapper {
    display: flex;
    align-items: center;
    border-radius: 12px;
    background: $white;
    border: 1px solid rgba(0, 0, 0, 0.5);
    height: 48px;
    padding: 0 16px;
  }
}

input[type='time']::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

/* For Firefox */
input[type='time']::-moz-focus-inner {
  border: 0;
}

/* Optional: remove the spin buttons (hours/minutes arrows) */
input[type='time']::-webkit-inner-spin-button,
input[type='time']::-webkit-clear-button {
  display: none;
}
</style>
